import { PromptBlueprint } from "@/types";

function updateApiType(
  promptBlueprint: Partial<PromptBlueprint>,
  apiType: string | null,
): Partial<PromptBlueprint> {
  return {
    ...promptBlueprint,
    metadata: {
      ...promptBlueprint.metadata,
      model: {
        ...promptBlueprint.metadata!.model!,
        api_type: apiType,
      },
    },
  };
}

export function ensureDefaultApiType(
  promptBlueprint: Partial<PromptBlueprint>,
): Partial<PromptBlueprint> {
  if (!promptBlueprint.metadata?.model) {
    return promptBlueprint;
  }

  const { provider } = promptBlueprint.metadata.model;
  const isOpenAI = provider === "openai" || provider === "openai.azure";
  const isCustomProvider = Boolean(promptBlueprint.provider_id);
  // OpenRouter routes chat, image and video generation and relies on api_type
  // (chat / images / video) to dispatch. It must NOT be force-nulled
  // like the other single-surface providers below.
  const isOpenRouter = provider === "openrouter";

  if (isOpenAI && !promptBlueprint.metadata.model.api_type) {
    return updateApiType(promptBlueprint, "chat-completions");
  }

  if (isOpenRouter) {
    // Preserve whatever the model / API selector resolved (images / video /
    // chat). A missing value is left untouched so the parameters
    // store can derive the capability from the selected model's supported_apis.
    return promptBlueprint;
  }

  if (!isOpenAI && !isCustomProvider && promptBlueprint.metadata.model.api_type !== null) {
    return updateApiType(promptBlueprint, null);
  }

  return promptBlueprint;
}
